<template>
  <div class="supply_content_sty">
    <div class="stem" :class="'one-' + question.questionId">
      <span class="index">{{ idx }}.</span>
      <span class="type">({{ checkType(question.type) }})</span>
      <p class="question_title" v-html="question.question"></p>
      <b class="question_score">{{ question.score }}分</b>
      <b class="grade" v-show="alreadyDo && question.myScore"
        >得分：{{ question.myScore }}分</b
      >
    </div>
    <div class="question_answer_content_sty">
      <el-input
        type="textarea"
        :autosize="{ minRows: 3, maxRows: 4 }"
        placeholder="请输入内容"
        v-model="question.myAnswerList[0]"
        :disabled="alreadyDo"
      >
      </el-input>
    </div>
    <p class="answer-row" v-if="!hideAnswer && question.answerList">
      参考答案：{{ question.answerList.join(",") }}
    </p>
  </div>
</template>

<script>
import { checkType } from "@/utils/index";
export default {
  data() {
    return {
      checkType,
    };
  },
  props: {
    // 索引
    idx: {
      type: Number,
      default: null,
    },
    // 题目对象
    question: {
      type: Object,
      default: function () {
        return {};
      },
    },
    alreadyDo: Boolean,
    hideAnswer: Boolean,
  },
  created() {
    this.question.myAnswerList = this.question.myAnswerList || [""];
  },
};
</script>


<style lang="less" scoped>
.stem {
  position: relative;
  margin: 20px 0;
  .index {
    display: inline-block;
    margin-top: 3px;
    vertical-align: top;
  }
  .type {
    display: inline-block;
    margin: 0 5px;
    color: #969696;
    vertical-align: top;
  }
  .question_title {
    display: inline-block;
    max-width: 83%;
    font-size: 14px;
    color: #333;
    vertical-align: top;
  }
  .question_score {
    display: inline-block;
    margin-left: 10px;
    color: #999;
    font-size: 14px;
    vertical-align: top;
  }
  .grade {
    position: absolute;
    top: 0;
    right: -20px;
    color: #ff0000;
  }
}
.question_answer_content_sty {
  width: 100%;
  ::v-deep .el-textarea__inner {
    font-family: inherit;
  }
}
.answer-row {
  margin-top: 10px;
  color: #67C23A;
}
</style>